import { useHistory } from 'react-router-dom'
import determineLink from 'utils/global/determineLink'

export const useNavigate = () => {
  const history = useHistory()

  return (location: string) => {
    switch (determineLink(location)) {
      case 'none':
        break
      case 'external':
      case 'protocol':
        window.open(location, '_blank', 'noopener,noreferrer')
        break
      default:
        history?.push(location)
    }
  }
}

export default useNavigate
